import React, { useEffect, useState } from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core'; // Using Worker from the library itself
import '@react-pdf-viewer/core/lib/styles/index.css';

import { useAlert } from '../../providers/AlertProvider';
import { CustomButton } from './CustomButton';
import { useAppBaseUrl } from '../../providers/SupabaseProvider';
import { getSessionUUID } from '../lib/AuthToken';

const PDFViewer = ({ pdfUrl, show }) => {
    const { showAlert } = useAlert();
    const appBaseUrl = useAppBaseUrl();
    const [blobUrl, setBlobUrl] = useState(null);

    // Fetch the PDF with the auth header and create a blob URL so the
    // <Viewer> component never makes an unauthenticated request to the proxy.
    useEffect(() => {
        if (!pdfUrl) return;
        let objectUrl;
        (async () => {
            try {
                const token = await getSessionUUID();
                const res = await fetch(pdfUrl, {
                    headers: token ? { 'Authorization': `Bearer ${token}` } : {},
                    credentials: 'include',
                });
                if (!res.ok) throw new Error(`${res.status}`);
                const blob = await res.blob();
                objectUrl = URL.createObjectURL(blob);
                setBlobUrl(objectUrl);
            } catch (err) {
                showAlert({
                    message: 'Failed to load PDF.',
                    type: 'danger',
                    buttons: [{ type: 'danger', label: 'Close' }],
                });
            }
        })();
        return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
    }, [pdfUrl]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleDownloadPdf = () => {
        if (!blobUrl) return;
        const fileName = pdfUrl.split('/').pop().split('?')[0];
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    

    return (
        <div style={{ height: '75vh', border: '1px solid #ddd', padding: '16px' }}>
            {blobUrl ? (
                <>
                    <span 
                        style={{ 
                            fontSize: '1.5rem', 
                            fontWeight: 'bold', 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            margin: '20px' 
                        }}
                    >
                        <span>PDF Viewer</span>
                        <div style={{ display: 'flex' }}>
                            <CustomButton 
                                onClick={() => handleDownloadPdf()} 
                                text="Download" 
                            />
                            <CustomButton 
                                onClick={() => show(false)} 
                                style={{ margin: '0px 0px 0px 10px' }} 
                                text="Close" 
                            />
                        </div>
                    </span>
                    <div 
                        style={{ 
                            height: '62vh', 
                            backgroundColor: '#ddd', 
                            margin: '10px 0px 20px 0px',
                            overflowY: 'scroll'
                        }}
                    >
                        <Worker workerUrl={`${appBaseUrl || window.location.origin}/pdf.worker.min.js`}>
                            <Viewer fileUrl={blobUrl} />
                        </Worker>
                    </div>
                </>
            ) : (
                <div style={{ padding: '20px' }}>{pdfUrl ? 'Loading PDF…' : 'Failed to load PDF'}</div>
            )}
        </div>
    );
};

export default PDFViewer;
